import get from "lodash/get";
import County from "./County";

export default class Utility {
  constructor(data, initModel = true) {
    if (initModel) {
      this.init(data)
    }
  }

  init(data) {
    if (!data) return;
    this.id = get(data, 'id', null)
    this.created = get(data, 'created', null)
    this.modified = get(data, 'modified', null)
    this.eia_Id = get(data, 'eia_Id', null)
    this.name = get(data, 'name', null)
    this.websiteUrl = get(data, 'websiteUrl', null)
    this.commercialRate = get(data, 'commercialRate', 0)
    this.industrialRate = get(data, 'industrialRate', 0)
    this.residentialRate = get(data, 'residentialRate', 0)
    this.counties = get(data, 'counties', []).map(i => new County(i))
  }

  toJSON() {
    const { id, created, modified, eia_Id, name, websiteUrl, commercialRate, industrialRate, residentialRate } = this;
    return { id, created, modified, eia_Id, name, websiteUrl, commercialRate, industrialRate, residentialRate, counties: this.counties.map(c => c.toJSON()) };
  }
}
